// extracted by mini-css-extract-plugin
export default {"productCategory":"ProductCategory_productCategory__H7Ci2","noPadding":"ProductCategory_noPadding__qOIk6"};